import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Space,
  Table,
  Tooltip, DatePicker,
} from "antd";
import { CommonStore, CardBillStore } from "../../../store";

function CardBillManage() {
  const [form] = Form.useForm();
  const { Column } = Table;
  const {RangePicker} = DatePicker;

  useEffect(() => {
    form.setFieldsValue({
      orderId: "",
      sendTime: null,
      beginDate: null,
      endDate: null,
    });
    resetSearchBth();
  }, []);
  const getFormData = (changeValue: any, allValues: any) => {
    CardBillStore.setSearchForm({ ...allValues });
  };
  const resetSearchBth = () => {
    CardBillStore.setSearchForm({});
    searchBtn();
  };
  const searchBtn = () => {
    CardBillStore.resetPage();
    CardBillStore.getBillPage();
  };

  return (
    <Fragment>
        <div className="formContent">
          <Form
            form={form}
            initialValues={CardBillStore.searchForm}
            autoComplete="off"
            labelCol={{ span: 6 }}
            onValuesChange={getFormData}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === "enter") {
                searchBtn();
              }
            }}
          >
            <Row justify="start">
              <Col span={8}>
                <Form.Item label="统计时间" name="sendTime">
                  <RangePicker
                      placeholder={["开始时间", "结束时间"]}
                      // showTime
                      format={'YYYY/MM/DD'}
                      // picker="month"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="闪信订单号" name="orderId">
                  <Input placeholder="请输入闪信订单号" />
                </Form.Item>
              </Col>

              <Col offset={2}>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={searchBtn}>
                      搜索
                    </Button>
                    <Button htmlType="reset" onClick={resetSearchBth}>
                      重置
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div>
          <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={CardBillStore.tableData.content}
              rowKey={(record) => record.no}
              loading={CardBillStore.tableLoad}
              scroll={{ x: 1000 }}
              pagination={{
                current: CardBillStore.pageData.page+1,
                pageSize: CardBillStore.pageData.size,
                onChange: CardBillStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: CardBillStore.tableData.totalElements,
                showTotal: () =>
                  `共计${CardBillStore.tableData.totalElements
                  }条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                ellipsis={true}
                width={150}
                title="账单日期"
                dataIndex="billDate"
              />
              <Column
                ellipsis={true}
                width={120}
                title="闪信订单"
                dataIndex="orderId"
              />
              <Column
                ellipsis={true}
                width={100}
                title="闪信发送次数(移动)"
                dataIndex="mobileCount"
              />
              <Column
                  ellipsis={true}
                  width={100}
                  title="闪信发送次数(联通)"
                  dataIndex="unicomCount"
              />
              <Column
                  ellipsis={true}
                  width={100}
                  title="闪信发送次数(电信)"
                  dataIndex="telecomCount"
              />
              <Column
                title="闪信发送次数总计"
                width={120}
                dataIndex="totalCount"
                ellipsis={true}
              />
            </Table>
          </ConfigProvider>
        </div>
    </Fragment>
  );
}

export default observer(CardBillManage);
